import { render, staticRenderFns } from "./Tlc.vue?vue&type=template&id=67443744"
import script from "./Tlc.vue?vue&type=script&lang=js"
export * from "./Tlc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports